import PackageDetail from "features/LoyaltyPackage/presentation/pages/PackageDetail";

function PackageDetailPage() {
  return <PackageDetail />;
}

export default PackageDetailPage;
